module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/vynil-92a8c2b92289bb57d3f02cb37d46d121.svg";